import {
  REPATRIATIONS_TRANSACTIONS_EXECUTE_REQUEST,
  REPATRIATIONS_TRANSACTIONS_EXECUTE_SUCCESS,
  REPATRIATIONS_TRANSACTIONS_EXECUTE_FAILURE,
} from './types/RepatriationsTransactionsExecuteActionsTypes';

export function postRepatriationsTransactionsExecuteRequestActionCreator(context,
  newDepartureDateTime,
  newDescription,
  newPlannedArrivalDateTime,
  newQuantity,
  newTransactionId) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_EXECUTE_REQUEST,
    payload: {
      appContext: context,
      params: {
        departureDateTime: newDepartureDateTime,
        description: newDescription,
        plannedArrivalDateTime: newPlannedArrivalDateTime,
        quantity: newQuantity,
        transactionId: newTransactionId,
      },
    },
  };
}

export function postRepatriationsTransactionsExecuteSuccessActionCreator(data) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_EXECUTE_SUCCESS,
    payload: data,
  };
}

export function postRepatriationsTransactionsExecuteFailureActionCreator(error) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_EXECUTE_FAILURE,
    payload: error,
    error: true,
  };
}
